const user = (userContextJson) => {
  return {
    ...userContextJson,
    hasScope: (scopes) => {
      return !userContextJson ? false : scopes.includes(userContextJson.scope);
    },
    hasRole: (role) => {
      return !userContextJson ? false : !!userContextJson.roles.find(r => r.scope === role);
    },
    isAuthenticated: !!userContextJson,
  };
};

export default user;
